module.exports = __webpack_public_path__ + "images/banner2.d6d3.png";